import { InventoryEventBus } from '../feature/inventory/inventory.model';
import { JoystickEventBus } from '../feature/joystick/joystick.model';
import { MerchantEventBus } from '../feature/merchant/merchant.model';
import { NarratorEventBus, NodeEnteredPayload } from '../feature/narrator/narrator.model';
import { NavigatorEventBus, POI_ID } from '../feature/navigator/navigator.model';
import { WorldEventBus } from '../feature/world/world.model';
import mitt from './emitter';

type Events = {
  [NavigatorEventBus.navigationEnd]: POI_ID;
  [NavigatorEventBus.navigationStart]: POI_ID;
  [NarratorEventBus.dialogStart]: void;
  [NarratorEventBus.narratorStart]: void;
  [NarratorEventBus.nodeEntered]: NodeEnteredPayload;
  [JoystickEventBus.showJoystick]: POI_ID;
  [JoystickEventBus.hideJoystick]: void;
  [WorldEventBus.initialise]: POI_ID;
  [InventoryEventBus.changed]: void;
  [MerchantEventBus.open]: void;
};

const eventBus = mitt<Events>();

export default eventBus;
